export default {
  email: /\S+@\S+\.\S+/, // formato email,
  emailForBenefits: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{3,4})+$/,
  phone: /^\d{8,}$/, // solo acepta números y un mínimo de 8 caracteres,
  numbers: /^[0-9]+$/,
};
